const fonts = {
    APP_MAIN: 'Rubik',
    APP_TITLES: 'Rubik',
    TABLE_TEXT: 'Rubik',
    MAIN_STATISTIC: 'Rubik',
    SECONDARY_STATISTIC: 'Rubik',
}

export default fonts
